export const fetchUserList = async (): Promise<string[]> => {
  try {
    const response = await fetch('/api/admin/list-users');
    const data = await response.json();
    if (data.success && data.users) {
      return data.users;
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch user list:', error);
    return [];
  }
};

export const fetchComprehensiveUserData = async (userId: string) => {
  try {
    const weeklyResponse = await fetch(`/api/trading/weekly-pnl/ALL`, {
      headers: { 'X-User-ID': userId }
    });
    const weeklyData = await weeklyResponse.json();
    
    const balanceResponse = await fetch(`/api/trading/balance`, {
      headers: { 'X-User-ID': userId }
    });
    const balanceData = await balanceResponse.json();
    
    const statusResponse = await fetch(`/api/trading/status`, {
      headers: { 'X-User-ID': userId }
    });
    const statusData = await statusResponse.json();
    
    return {
      weekly: weeklyData,
      balance: balanceData,
      status: statusData
    };
  } catch (error) {
    console.error(`Error fetching data for ${userId}:`, error);
    return null;
  }
};

export const maskUserId = (userId: string): string => {
  if (userId.length <= 4) return userId;
  return `${userId.slice(0, 2)}****${userId.slice(-2)}`;
};
